import { Injector } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';

import { NgxPrimengFormService, INgxPrimengForm, INgxPrimengFormResult } from 'ngx-primeng-form';
import { FormBaseComponent } from './form.base';

export abstract class DynamicFormBaseComponent<TModel> extends FormBaseComponent<TModel>{

    // define form base service
    protected ngxPrimengFormService: NgxPrimengFormService;

    constructor(dynamicFormInjector: Injector) {
        super(dynamicFormInjector);
        // prepare instance
        this.ngxPrimengFormService = dynamicFormInjector.get(NgxPrimengFormService);
    }

    // prepare form
    protected prepareForm(formBuilder: FormBuilder, jsonForms: INgxPrimengForm[]): INgxPrimengFormResult {
        return this.ngxPrimengFormService.prepareForm(formBuilder, jsonForms);
    }

    // load dynamic forms
    protected loadRemoteJsonForm(formBuilder: FormBuilder, formObservable: Observable<INgxPrimengForm[]>): Observable<INgxPrimengFormResult> {
        const observable = new Observable<INgxPrimengFormResult>((observer) => {
            const ref = formObservable.subscribe(forms => {
                // load form data
                const result = this.prepareForm(formBuilder, forms);
                // emit event
                observer.next(result);
                // complete
                observer.complete();
            }, error => {
                observer.error(error);
            });
            this.subscription.add(ref);
        });
        return observable;
    }

}